/* global jQuery */

angular.module('app.cars', ['ngRoute', 'ngResource', 'angular-jwt', 'ngFileUpload', 'bw.paging', 'uiGmapgoogle-maps'])
.config(['$routeProvider', function _($routeProvider) {
  $routeProvider.when('/cars/cars', {
    template: require('./cars.html'),
    controller: 'carsCtrl',
  });
}])
.controller('carsCtrl', ($rootScope, $scope, $translate, $resource, $route, $location, $cookies, $routeParams, $window, AuthService, envService) => {
  $rootScope.mainmenu = 'service';
  $rootScope.menu = 'cars';
  const APIURL = envService.read('apiUrl');
  if (!AuthService.isAuthenticated()) {
    $location.path('/login');
    return;
  }

  $scope.modifyMode = false;
  $scope.restoreMode = false;
  $scope.title = $translate.instant('차량');
  $scope.totalCount = 0;
  $scope.pageSize = 20;
  $scope.currentPage = 1;
  $scope.targetType = '-1';
  $scope.targetBrand = '-1';
  $scope.query = '';
  $scope.cars = [];
  $scope.addCar = { MAKER_ID: -1, MAKER_CD: '', TB_GOODS_ID: -1, PRICE: '', TYPE_ID: -1, CAR_NAME: '', CARS_ID: -1 };

  $resource(`${APIURL}/admin/cars`).get({ q: $scope.query }, (data) => {
    $scope.cars = data.cars;
    $scope.totalCount = data.totalCount;
    $scope.currentPage = 1;
    console.log(data);
  }, (err) => {
    console.error(err);
    if (err.data && err.data.msg) {
      alert(err.data.msg);
    } else {
      alert($translate.instant('알수 없는 에러 입니다.'));
    }
  });

  $resource(`${APIURL}/admin/cars/brands`).get({}, (data) => {
    $scope.brands = data.brands;
  }, (err) => {
    if (err.data && err.data.msg) {
      alert(err.data.msg);
    } else {
      alert($translate.instant('알수 없는 에러 입니다.'));
    }
  });
  $resource(`${APIURL}/admin/cars/types`).get({}, (data) => {
    $scope.types = data.types;
    console.log($scope.types);
  }, (err) => {
    if (err.data && err.data.msg) {
      alert(err.data.msg);
    } else {
      alert($translate.instant('알수 없는 에러 입니다.'));
    }
  });
  $scope.paging = (page) => {
    $resource(`${APIURL}/admin/cars`).get({ page: page - 1, q: $scope.query, itemcd: $scope.targetType, makercd: $scope.targetBrand },
      (data) => {
        console.log(data);
        $scope.cars = data.cars;
        $scope.totalCount = data.totalCount;
        $scope.currentPage = page || 1;
      }, (err) => {
        console.error(err);
        if (err.data && err.data.msg) {
          alert(err.data.msg);
        } else {
          alert($translate.instant('알수 없는 에러 입니다.'));
        }
      });
  };
  $scope.view = (car) => {
    console.log(car);
    $scope.car = car;
    $scope.modifyMode = false;
    jQuery('#modal-4').modal('show');
  };
  $scope.addView = () => {
    $scope.addCar = {};
    jQuery('#modal-5').modal('show');
  };

  $scope.updateCarMaker = () => {
    for (let makerIdx = 0; makerIdx < $scope.brands.length; makerIdx += 1) {
      const brand = $scope.brands[makerIdx];
      if ($scope.addCar.MAKER_ID == brand.ID) { // eslint-disable-line eqeqeq
        $scope.addCar.MAKER_CD = brand.MAKER_CD;
      }
    }
  };

  $scope.close = () => {
    jQuery('#modal-4').modal('hide');
    jQuery('#modal-5').modal('hide');
  };

  $scope.updateCarType = () => {
    for (let typeIdx = 0; typeIdx < $scope.types.length; typeIdx += 1) {
      const type = $scope.types[typeIdx];
      if ($scope.addCar.TYPE_ID == type.ITEMCD) { // eslint-disable-line eqeqeq
        $scope.addCar.TB_GOODS_ID = type.ITEMCD;
        $scope.addCar.PRICE = type.PRICE;
        break;
      }
    }
  };

  $scope.delete = () => {
    if ($window.confirm($translate.instant('차량을 삭제하시겠습니까?'))) {
      $resource(`${APIURL}/admin/cars/:carsId`, { carsId: $scope.car.ID }).delete(() => {
        alert($translate.instant('삭제되었습니다'));
        for (let carIdx = 0; carIdx < $scope.cars.length; carIdx += 1) {
          const car = $scope.cars[carIdx];
          if ($scope.car.ID === car.ID) {
            $scope.cars.splice(carIdx, 1);
            break;
          }
        }
        jQuery('#modal-4').modal('hide');
      }, (err) => {
        console.error(err);
        if (err.data && err.data.msg) {
          alert(err.data.msg);
        } else {
          alert($translate.instant('알수 없는 에러 입니다.'));
        }
      });
    }
  };
  $scope.stopSell = () => {
    if ($window.confirm($translate.instant('판매 중지 하시겠습니까?'))) {
      $resource(`${APIURL}/admin/cars/:carsId/sell`, { carsId: $scope.car.ID }).delete((data) => {
        alert($translate.instant('판매 중지되었습니다.'));
        const car = data.car;
        $scope.cars = $scope.cars.map((_car) => {
          if (car.ID === _car.ID) {
            return car;
          }
          return _car;
        });
        jQuery('#modal-4').modal('hide');
      }, (err) => {
        console.error(err);
        if (err.data && err.data.msg) {
          alert(err.data.msg);
        } else {
          alert($translate.instant('알수 없는 에러 입니다.'));
        }
      });
    }
  };
  $scope.restore = () => {
    $scope.addCar = { MAKER_ID: $scope.car.MAKER_CD, MAKER_CD: $scope.car.MAKER_CD, TB_GOODS_ID: $scope.car.TB_GOODS_ID, PRICE: $scope.car.PRICE, TYPE_ID: -1, CAR_NAME: $scope.car.CAR_NAME, CARS_ID: $scope.car.ID };
    $scope.modifyMode = true;
    $scope.restoreMode = true;
  };
  $scope.restoreSubmit = () => {
    if ($scope.addCar.MAKER_CD === undefined) {
      alert($translate.instant('제조사를 선택해주세요.'));
      return;
    }
    if ($scope.addCar.CAR_NAME === undefined || $scope.addCar.CAR_NAME.length < 1) {
      alert($translate.instant('차량명을 입력해주세요.'));
      return;
    }
    if ($scope.addCar.TB_GOODS_ID === undefined) {
      alert($translate.instant('차량 종류를 선택해주세요.'));
      return;
    }
    $resource(`${APIURL}/admin/cars/${$scope.addCar.CARS_ID}/sell`).save({ TB_GOODS_ID: $scope.addCar.TB_GOODS_ID }, (data) => {
      alert($translate.instant('판매 재개되었습니다.'));
      const car = data.car;
      $scope.cars = $scope.cars.map((_car) => {
        if (car.ID === _car.ID) {
          return car;
        }
        return _car;
      });
      jQuery('#modal-4').modal('hide');
      jQuery('#modal-5').modal('hide');
    });
  };

  $scope.modify = () => {
    $scope.addCar = { MAKER_ID: $scope.car.MAKER_CD, MAKER_CD: $scope.car.MAKER_CD, TB_GOODS_ID: $scope.car.TB_GOODS_ID, PRICE: $scope.car.PRICE, TYPE_ID: -1, CAR_NAME: $scope.car.CAR_NAME, CARS_ID: $scope.car.ID };
    for (let typeIdx = 0; typeIdx < $scope.types.length; typeIdx += 1) {
      const type = $scope.types[typeIdx];
      if ($scope.car.TB_GOODS_ID === type.ITEMCD) {
        $scope.addCar.TYPE_ID = type.ITEMCD;
        $scope.type = type;
        break;
      }
    }
    $scope.modifyMode = true;
  };

  $scope.submit = () => {
    if ($scope.addCar.MAKER_CD === undefined) {
      alert($translate.instant('제조사를 선택해주세요.'));
      return;
    }
    if ($scope.addCar.CAR_NAME === undefined || $scope.addCar.CAR_NAME.length < 1) {
      alert($translate.instant('차량명을 입력해주세요.'));
      return;
    }
    if ($scope.addCar.TB_GOODS_ID === undefined) {
      alert($translate.instant('차량 종류를 선택해주세요.'));
      return;
    }

    $resource(`${APIURL}/admin/cars/${$scope.addCar.MAKER_CD}/add`).save($scope.addCar, (data) => {
      console.log(data);
      $scope.cars.push(data.car);
      jQuery('#modal-5').modal('hide');
    }, (err) => {
      console.error(err);
      if (err.data && err.data.msg) {
        alert(err.data.msg);
      } else {
        alert($translate.instant('알수 없는 에러 입니다.'));
      }
    });
  };

  $scope.modifySubmit = () => {
    if ($scope.addCar.MAKER_CD === undefined) {
      alert($translate.instant('제조사를 선택해주세요.'));
      return;
    }
    if ($scope.addCar.CAR_NAME === undefined || $scope.addCar.CAR_NAME.length < 1) {
      alert($translate.instant('차량명을 입력해주세요.'));
      return;
    }
    if ($scope.addCar.TB_GOODS_ID === undefined) {
      alert($translate.instant('차량 종류를 선택해주세요.'));
      return;
    }

    $resource(`${APIURL}/admin/cars/${$scope.addCar.CARS_ID}/modify`).save($scope.addCar, (data) => {
      const car = data.car;
      for (let carIdx = 0; carIdx < $scope.cars.length; carIdx += 1) {
        const curCar = $scope.cars[carIdx];
        if (car.ID === curCar.ID) {
          $scope.cars[carIdx] = car;
          break;
        }
      }
      jQuery('#modal-4').modal('hide');
      jQuery('#modal-6').modal('hide');
    }, (err) => {
      console.error(err);
      if (err.data && err.data.msg) {
        alert(err.data.msg);
      } else {
        alert($translate.instant('알수 없는 에러 입니다.'));
      }
    });
  };
});



// WEBPACK FOOTER //
// ./src/app/cars/cars.js